export default __webpack_public_path__ + "static/media/swag1.ccdf3a5b.jpg";